import { createAction } from 'redux-action';
import axios from 'axios';
import { AxiosCallError, AxiosCallRequest, AxiosCallSuccess } from './commonActions';
import { get_service_endpoint } from '../../ServiceEndpoints.js';
import { serializedMCQData } from '../../Utils/mcqHelpers.js';

let ep = get_service_endpoint('question-bank');

const addMcqs = createAction('ADD_MCQS_QUESTIONS');
export const setCurrentMcq = createAction('SET_CURRENT_MCQ');
export const setQuestionDetails = createAction('SET_QUESTION_DETAILS');
export const updateQuestionDetails = createAction('UPDATE_QUESTION_DETAILS');
export const setProgress = createAction('SET_PROGRESS');

export const fetchMcqQuestion = mcq_id => {
  return (dispatch, getState) => {
    dispatch(AxiosCallRequest());
    let url = `${ep}/v1/questions/${mcq_id}?include=options`;
    const state = getState();
    return axios
      .get(url)
      .then(res => {
        const serializedMcq = serializedMCQData(res.data);
        dispatch(setCurrentMcq(serializedMcq));
        dispatch(addMcqs(serializedMcq));
        dispatch(AxiosCallSuccess());
      })
      .catch(error => {
        dispatch(AxiosCallError(error));
      });
  };
};
